import { createContext, useReducer } from 'react';

const ContextStore = createContext();

/** @type {IAppState} */
const initStore = {
  init: false,
  error: null,
  appConfig: null,
  program: null,
  me: null,
  missions: null,
  items: null,
  redeemables: null,
  lang: null,
  tierColor: '#000',
  tierMission: null,
  showMissionOrReward: 'mission',
  isBackdropLoading: false,
  navData: {
    isTiers: false,
    isCoupons: false
  },
  registrationData: {
    isSave: false,
    tier: null,
    formFile: null,
    data: null,
    step: 0
  },
  errDialog: {
    open: false,
    title: null,
    message: null,
    code: null
  },
  msgDialog: {
    open: false,
    title: null,
    message: null
  },
  memberCodeDialog: {
    open: false
  },
  imageDialog: {
    open: false
  },
  floatMenu: {
    show: true
  },
  userInfo: {
    open: false
  },
  hasUnreadNotifications: false,
  isMobile: true,
  isSupportedFirebase: true
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'INIT':
      return Object.assign({}, state, { ...action.payload });
    case 'SET_ME':
      return Object.assign({}, state, { me: action.payload });
    case 'SET_NAV_DATA':
      return Object.assign({}, state, { navData: { ...action.payload } });
    case 'SET_REGISTRATION_DATA':
      return Object.assign({}, state, { registrationData: { ...action.payload } });
    case 'SET_ERROR':
      return Object.assign({}, state, { error: action.payload });
    case 'SWITCH_LANGUAGE':
      return Object.assign({}, state, { lang: action.payload });
    case 'SET_BACKDROP_LOADING':
      return Object.assign({}, state, { isBackdropLoading: action.payload });
    case 'SET_ERROR_DIALOG':
      return Object.assign({}, state, { errDialog: action.payload });
    case 'SET_MESSAGE_DIALOG':
      return Object.assign({}, state, { msgDialog: action.payload });
    case 'SET_MEMBER_CODE_DIALOG':
      return Object.assign({}, state, { memberCodeDialog: action.payload });
    case 'SET_SHOW_MISSION_OR_REWARD':
      return Object.assign({}, state, { showMissionOrReward: action.payload });
    case 'SWITCH_SHOW_TYPE':
      return Object.assign({}, state, { isMobile: action.payload });
    case 'SET_SUPPORT_FIREBASE':
        return Object.assign({}, state, { isSupportedFirebase: action.payload });
    case 'SWITCH_IMAGE_DIALOG':
      return Object.assign({}, state, { imageDialog: action.payload });
    case 'SWITCH_SHOW_FLOAT_MENU':
      return Object.assign({}, state, { floatMenu: action.payload });
    case 'SWITCH_UNREAD_TARGET':
      return Object.assign({}, state, { hasUnreadNotifications: action.payload });
    case 'SWITCH_USER_INFO':
      return Object.assign({}, state, { userInfo: action.payload });
    default:
      return state;
  }
};

const StateProvider = (props) => {
  const [store, dispatch] = useReducer(reducer, initStore);
  return (
    <ContextStore.Provider
      value={{
        ...store,
        dispatch
      }}
    >
      {props.children}
    </ContextStore.Provider>
  );
};

export default ContextStore;
export { StateProvider };